import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Redirect, withRouter} from 'react-router-dom';
import classNames from 'classnames';
import {requestLogin} from '../../actions/authActions';
import logo from '../../../res/favicon.png';
// import Footer from '../layout/Footer';

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {username: '', password: ''};
        this.handleChangeUsername = this.handleChange.bind(this, 'username');
        this.handleChangePassword = this.handleChange.bind(this, 'password');
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(field, event) {
        this.setState({[field]: event.target.value});
    }

    handleSubmit(event) {
        event.preventDefault();
        this.props.requestLogin(this.state.username, this.state.password);
    }

    render() {
        const {error, loading, logged} = this.props;
        if (logged) {
            return <Redirect to={{pathname: '/', state: {from: this.props.location}}} />;
        }
        return (
            <>
                <div className="login text-center">
                    <form className="form-signin" onSubmit={this.handleSubmit}>
                        <img className="mb-4" src={logo} alt="Swarm logo" width="72" height="72" />
                        <h1 className="h3 mb-3 font-weight-normal">Swarm</h1>
                        <div className="separator" />
                        <div className="form-content">
                            <label htmlFor="login_username" className="sr-only">Username</label>
                            <input type="text" id="login_username" className={classNames('form-control', {'is-invalid': !!error})}
                                placeholder="Username" required autoFocus
                                value={this.state.username} onChange={this.handleChangeUsername} />
                            <label htmlFor="login_password" className="sr-only">Password</label>
                            <input type="password" id="login_password" className={classNames('form-control', {'is-invalid': !!error})}
                                placeholder="Password" required
                                value={this.state.password} onChange={this.handleChangePassword} />
                            {error && <span className="invalid-feedback">Invalid user or password.</span>}
                            <div className="text-center login-button">
                                <button className="btn btn-primary" type="submit" disabled={loading}>
                                    Login
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
                {/* <Footer /> */}
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    error: state.auth.error,
    loading: state.auth.loading,
    logged: state.auth.logged,
});

export default connect(mapStateToProps, {requestLogin})(withRouter(Login));
